import { t } from "@lingui/core/macro";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import React from "react";

import { ProfileScreen } from "../../screens";
import { MembershipsStackNavigator } from "./MembershipsStackNavigator";
import { PackagesStackNavigator } from "./PackagesStackNavigator";
import { ProfileStackNavigatorParamList } from "./types";

const Stack = createNativeStackNavigator<ProfileStackNavigatorParamList>();

export const ProfileStackNavigator = () => {
  return (
    <Stack.Navigator
      initialRouteName="ProfileHome"
      screenOptions={(screenProps) => ({
        headerShown: false,
      })}
    >
      <Stack.Screen
        name={"ProfileHome"}
        options={{
          title: t`Profile`,
        }}
        component={ProfileScreen}
      />
      <Stack.Screen
        name={"Memberships"}
        options={{
          title: t`Memberships`,
        }}
        component={MembershipsStackNavigator}
      />
      <Stack.Screen
        name={"Packages"}
        options={{
          title: t`Packages`,
        }}
        component={PackagesStackNavigator}
      />
    </Stack.Navigator>
  );
};
